import api from "./axiosConfig";
import { hashPassword } from "./api";

export const showProfileClient = async (id) => {
  try {
    var response = await api.get(`/api/empresas/${id}`);
    var resLogo = await getClientLogo(response.data.id);
    if (resLogo){
      response.data.logo = resLogo;
    }
    //console.log('response.data.logo: ', response.data.logo);
    return response.data;
  } catch (error) {
    console.error("Error al consultar el cliente:", error);
    throw error;
  }
};

export const showProfile = async (id) => {
  try {
    var response = await api.get(`/api/profile`);
    /*var resLogo = await getClientLogo(response.data.id);
    if (resLogo){
      response.data.logo = resLogo;
    }
    //console.log('response.data.logo: ', response.data.logo);*/
    return response.data;
  } catch (error) {
    console.error("Error al consultar el perfil de usuario:", error);
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    // (2026-05-13) Aplicar SHA-256 a old_password / new_password antes de enviar.
    // El backend en modo AUTH_HASH_MODE='sha256' rechaza cualquier otro formato.
    const payload = { ...data };
    if (payload.old_password) {
      payload.old_password = hashPassword(payload.old_password);
    }
    if (payload.new_password) {
      payload.new_password = hashPassword(payload.new_password);
    }
    const response = await api.put("/api/profile/change-password", payload);
    return response.data;
  } catch (error) {
    console.error("Error al consultar el cambiar contraseña:", error);
    throw error;
  }
};

export const getClientLogo = async (id) => {
  try {
    const response = await api.get(`/api/empresas/${id}/logo`, {
      responseType: "arraybuffer" // muy importante para manejar binarios
    });

    // Convertir a base64 para usar en jsPDF
    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );

    // Detectar tipo de imagen (puedes ajustarlo si sabes que siempre es PNG)
    return `data:image/png;base64,${base64}`;
  } catch (err) {
    // (2026-05-17) FIND-6: el logo es OPCIONAL. La ausencia/permiso del
    // logo devuelve 4xx (404 sin logo, 403 sin acceso, etc.) — son casos
    // ESPERADOS y no deben ensuciar la consola. Solo se loguea una falla
    // real: sin respuesta (red) o error de servidor (5xx).
    const _st = err?.response?.status;
    if (!_st || _st >= 500) {
      console.error("Error al obtener logo del cliente:", err);
    }
    return null;
  }
};